import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../../lib/supabase'

export interface Cashier {
  id: string
  name: string
  email: string | null
  role: 'staff' | 'manager'
  status: 'active' | 'inactive'
  lastActivityAt: Date | null
}

async function fetchCashiers(): Promise<Cashier[]> {
  const { data, error } = await supabase
    .from('cashier_pins')
    .select('id, name, email, role, status, last_activity_at, created_at')
    .order('created_at', { ascending: false })

  if (error) throw error

  return data.map((c) => ({
    id: c.id,
    name: c.name,
    email: c.email,
    role: c.role as 'staff' | 'manager',
    status: c.status as 'active' | 'inactive',
    lastActivityAt: c.last_activity_at ? new Date(c.last_activity_at) : null,
  }))
}

export function useCashiers() {
  return useQuery({
    queryKey: ['cashiers'],
    queryFn: fetchCashiers,
  })
}
